<template>
  <div class="resend-parent-invitation-modal">
    <Modal @closeModal="$emit('closeTriggered')">
      <!-- MODAL TITLE -->
      <div slot="modal-title">
        <span class="font-weight-bold">Send Parent Invitation</span>
      </div>

      <!-- MODAL BODY -->
      <div slot="modal-body">
        <!-- ERROR ALERT -->
        <div style="position: relative; top: -30px; margin-bottom: -8px">
          <AuthAlertCard
            v-if="show_alert"
            :alert_type="alert_type"
            :alert_msg="alert_msg"
          ></AuthAlertCard>
        </div>

        <!-- STUDENT INFO -->
        <div
          class="student-info d-flex justify-content-start align-items-center nowrap"
        >
          <div
            class="avatar avatar_md avatar-square"
            :class="student_image ? 'border_brand_inverse' : null"
          >
            <img
              v-lazy="student_image"
              :alt="getStudentInitial"
              class="avatar-img"
              v-if="student_image"
            />
            <div
              class="avatar-text white-text"
              :class="setStudentAvatarBg"
              v-else
            >
              {{ getStudentInitial }}
            </div>
          </div>

          <div class="info">
            <div class="name font-weight-bold color_text text-capitalize">
              {{ student_name }}
            </div>
            <div class="class-year color_grey_dark">{{ student_class }}</div>
          </div>
        </div>
        <!-- STUDENT INFO -->

        <form action @submit.prevent autocomplete="off">
          <!-- Parent’s Email -->
          <div class="modal-body-row row">
            <div class="col-12">
              <label for="parentEmail" class="control-label label-compact"
                >Parent’s Email</label
              >
              <input
                type="email"
                v-model="form.parent_email"
                class="form-control"
                id="parentEmail"
                required
                placeholder="Enter email address"
              />
            </div>
          </div>

          <!-- Parent’s phone number -->
          <div class="modal-body-row row">
            <div class="col-12">
              <label for="parentNumber" class="control-label label-compact"
                >Parent’s phone number</label
              >
              <input
                type="number"
                v-model="form.parent_phone_number"
                class="form-control"
                id="parentPhoneNumber"
                required
                placeholder="Enter phone number"
              />
            </div>
          </div>

          <!-- SEND INVITATION-->
          <div class="modal-body-row row mb-1">
            <div
              class="col-12 d-flex justify-content-end align-items-center nowrap"
            >
              <button
                class="btn btn-md brand_navy transparent_bg z-depth-0 mr-2"
                @click="$emit('closeTriggered')"
              >
                Cancel
              </button>

              <button
                type="submit"
                class="btn btn-md btn-accent"
                ref="invitationBtn"
                :disabled="isDisabled"
                @click="sendInvitation"
              >
                Send Invitation
              </button>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  </div>
</template>

<script>
import { setInitial } from "@/scripts/utilities";
import { setProfileBg } from "@/scripts/profile-colors";
import Modal from "@/components/globalComps/Modal";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ResendInvitationModal",

  components: {
    Modal,
    AuthAlertCard: () =>
      import(
        /* webpackChunkName: "AuthAlertCard" */
        "@/components/globalComps/AuthComps/AuthAlertCard.vue"
      ),
  },

  props: {
    student_name: {
      type: String,
      default: "Child's name",
    },
    student_class: {
      type: String,
      default: "Child's class",
    },
    student_image: String,
    student_id: Number,
    class_id: [String, Number],
  },

  computed: {
    ...mapGetters(["getSchoolDetails"]),

    getStudentInitial() {
      return setInitial(this.student_name);
    },

    setStudentAvatarBg() {
      return setProfileBg(this.student_name);
    },

    isDisabled() {
      return (
        this.form.parent_email.length <= 3 ||
        this.form.parent_phone_number.length <= 10
      );
    },

    getInvitePayload() {
      return {
        type: "parent",
        contacts: [
          { email: this.form.parent_email },
          { phone_number: this.form.parent_phone_number },
        ],
        class_id: Number(this.class_id),
        school_id: Number(this.getSchoolDetails?.id),
        student_id: this.student_id,
        relationship: "school proprietor",
      };
    },
  },

  data() {
    return {
      show_alert: false,
      alert_type: null, //SET TO EITHER SUCCESS OR ERROR
      alert_msg: "",
      form: {
        parent_email: "",
        parent_phone_number: "",
      },
    };
  },

  methods: {
    ...mapActions(["inviteSchoolParent", "schoolInviteParent"]),

    sendInvitation() {
      this.$refs.invitationBtn.disabled = true;
      this.$refs.invitationBtn.innerHTML =
        '<div class="icon-dotted-roller font-17 mr-2 animate"></div>Please wait...';

      this.inviteSchoolParent({
        receiver_email: this.form.parent_email,
        receiver_phone: this.form.parent_phone_number,
        extra_data: this.student_id.toString(),
      })
        .then((response) => {
          console.log("Parent inviattion response", response);
          if (response?.code === 200) {
            setTimeout(() => {
              this.show_alert = false;

              this.$refs.invitationBtn.disabled = true;
              this.$refs.invitationBtn.innerHTML =
                '<div class="icon-accept font-18 mr-2"></div>Invite sent';
            }, 1000);

            setTimeout(() => {
              let dialog_data = {
                msg: "Parent invite was sent successfully",
                type: "success",
              };
              this.$emit("showAlertCard", dialog_data);
              this.$emit("closeTriggered");
            }, 3000);
          }
          // HANDLE NON 200 RESPONSE
          else {
            setTimeout(() => {
              this.show_alert = true;
              this.alert_type = "error";
              this.alert_msg = response?.message || "Error sending invite";

              this.$refs.invitationBtn.innerText = "Send Invitaion";
              this.$refs.invitationBtn.disabled = false;
            }, 1000);
          }
        })
        .catch((err) => {
          setTimeout(() => {
            this.show_alert = true;
            this.alert_type = "error";
            this.alert_msg = "Error sending invite";

            this.$refs.invitationBtn.innerText = "Send Invitaion";
            this.$refs.invitationBtn.disabled = false;
          }, 1000);
          console.log("error sending invite", err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.resend-parent-invitation-modal {
  .student-info {
    margin: 10px 0 35px;
    .avatar {
      margin-right: 15px;
    }

    .name {
      font-size: 16px;
      line-height: 22px;
      margin-bottom: 3px;
    }

    .class-year {
      font-size: 13px;
      line-height: 18px;
    }
  }
}
</style>
